export const reduceDeactivateBoardRequest = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isDeactivatingBoard: true },
  };
};

export const reduceDeactivateBoardSuccess = (
  state,
  { payload: { boardId } },
) => {
  const { byId } = state?.base || {};
  const board = byId[boardId];
  const boardWithArchive = { ...board, active: false, archived: true };

  return {
    ...state,
    base: { ...state.base, byId: { ...byId, [boardId]: boardWithArchive } },
    ui: { ...state.ui, isDeactivatingBoard: false },
  };
};

export const reduceDeactivateBoardFailure = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isDeactivatingBoard: false },
  };
};
